import React, { useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { ContextData } from "../../context/Context";
import axios from "axios";
import { Getrequest } from "../../context/AxiosRequest";
import  jwtDecode  from "jwt-decode";
import InnerLoarder from "../InnerLoarder";





const ApplicantPrivateRoute = ({ children }) => {


  const { accesstoken, setaccesstoken,setUserTokens } = useContext(ContextData);
  const [loading, setLoading] = useState(true); // Track loading state

  useEffect(() => {
    const fetchAccessToken = async () => {

      if (!accesstoken) {

            const response = await Getrequest(`/pub/refresh_token`,accesstoken)

                 if(response.status){   
                     
                     const decode = await jwtDecode(response.accesstoken)
                        
                        if(decode){
               
                            
                             setUserTokens(decode.usertoken) 
                             setaccesstoken(response.accesstoken)
                                // loader
                            
                        }
                        }
                        
                 }
      setLoading(false); // Stop loading after attempting refresh
    };

    fetchAccessToken();
  }, [accesstoken, setaccesstoken]);

  if (loading) return(
        <div className="w-vh  h-lvh flex justify-center items-center">
              <div className="w-96">
              <InnerLoarder />
              <p className='text-center font-extrabold text-xs'>Powered By MastermindTech</p>
              </div>
       
             </div>
  ) 
  return accesstoken ? children : <Navigate to="/home" />;
};

export default ApplicantPrivateRoute;
